import React from 'react'
import { massPlaybookUpdateProgressStatus } from '../../playbook.helpers'
import { organizationColumn, progressColumn } from '../shared/BulkEditColumns'

const matchinContentCol = {
  label: 'Matching Content',
  accessor: 'content',
  format: (value) => (
    <div style={{ maxWidth: '400px', whiteSpace: 'initial' }}>
      <span>{value}</span>
    </div>
  ),
}

const columns = (isSingleColumn) => [
  {
    label: 'Playbook',
    accessor: 'config_name',
    format: (value, row) => (
      <div
        style={{
          maxWidth: isSingleColumn ? '550px' : '250px',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
        }}
      >
        <a href={`/playbooks/${row.config_id}/checklist`} target="_blank" rel="noreferrer">
          {value}
        </a>
      </div>
    ),
  },
]

export const getColumns = (isUpdate, progress, showOrgs) => {
  const isSingleColumn = !showOrgs && !isUpdate
  let cols = [...columns(isSingleColumn)]
  if (isUpdate) {
    cols = [matchinContentCol, ...cols]
  }
  if (showOrgs) {
    cols = [...cols, organizationColumn]
  }
  if (progress !== massPlaybookUpdateProgressStatus.INITIAL) {
    cols = [progressColumn, ...cols]
  }
  return cols
}
